import { useCallback, useEffect, useState } from "react";
import { traerCantidadDeNotasEnvasado } from "../service/getCountNotes";

export function useCountNotes(clienteId) {
  const [data, setData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!clienteId) return;

    setLoading(true);
    setError(null);

    try {
      const res = await traerCantidadDeNotasEnvasado(clienteId);
      setData(res.cantidad || 0);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [clienteId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refresh = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refresh,
  };
}
